import { render, staticRenderFns } from "./AccidentPrevent.vue?vue&type=template&id=a12ee9fa&"
import script from "./AccidentPrevent.vue?vue&type=script&lang=js&"
export * from "./AccidentPrevent.vue?vue&type=script&lang=js&"
import style0 from "./AccidentPrevent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12ee9fa')) {
      api.createRecord('a12ee9fa', component.options)
    } else {
      api.reload('a12ee9fa', component.options)
    }
    module.hot.accept("./AccidentPrevent.vue?vue&type=template&id=a12ee9fa&", function () {
      api.rerender('a12ee9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/AccidentPrevent.vue"
export default component.exports